<template>
  <div class="qr-wrap">
    <div class="qr-wrap-con">
      <QrcodeVue
        v-show="qrText"
        :value="qrText"
        :size="qrsize"
        level="H"
      />
    </div>
    <QrRetry
      v-if="retry"
      :size="{width: `${qrsize}px`, height: `${qrsize}px`}"
      class="qr-retry"
      @emitClickRetry="emitClickRetry"
    />
    <div
      class="title-wrap"
    >
      <template v-if="isSourcePrint">
        <span class="title-print"><em>批量打印</em>功能限时免费 <br>微信扫码关注即可免费使用</span><span class="tips-icon sprite-login sprite-login-tips-icon" />
      </template>
      <template v-else>
        <span class="title">微信扫码<em>关注公众号</em>即可<em>登录/注册</em></span><span class="tips-icon sprite-login sprite-login-tips-icon" />
      </template>

      <div
        :class="{tipsx: isSourcePrint}"
        class="tips sprite-login sprite-login-tips-cover"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import QrcodeVue from 'qrcode.vue'
import { formatDate } from '@/utils/shared'
import QrRetry from '@/components/common/QrRetry'
import { getOfficialAccountLogin, mpAuth } from '@/api/officialAccountLogin'
import login from '@/client/modules/login.js'
import { REPORT_LOGIN_TYPE, REPORT_PARAMS } from '@/config/dataMap'
import * as LoginHandler from '@/services/login/loginHandler.js'

export default {
  name: 'OfficialAccountLogin',

  components: {
    QrcodeVue,
    QrRetry
  },

  props: {
    qrsize: {
      type: Number,
      default: 150
    }
  },

  data () {
    return {
      qrText: '',
      retry: false,
      identify: '',
      loopTimer: null,
      expiryTimer: null,
      authCheckTime: 2 // 秒
    }
  },

  computed: {
    ...mapGetters(['token', 'openId']),

    isSourcePrint () {
      return this.$route.query?.custom === '1' && REPORT_PARAMS.show_from === '6031'
    }
  },

  created () {
    this.getOfficialAccountLogin()
  },
  beforeDestroy () {
    this.clearLoopTimer()
  },
  methods: {
    /** 获取跳转公众号二维码 */
    async getOfficialAccountLogin () {
      try {
        const res = await getOfficialAccountLogin()
        if (!res.url) {
          this.retry = true
          return
        }

        this.clearLoopTimer()
        clearTimeout(this.expiryTimer)
        this.qrText = res.url
        this.retry = false
        this.identify = res.identify
        const ttl = Number(res.ttl) * 1000
        const show_time = formatDate(new Date())
        login.REPORT.reportLoginPageShow({ show_time, login_type: REPORT_LOGIN_TYPE.officialAccount, page_show: 3 })

        // 轮询是关注公众号结果
        this.loopMpAuth()

        // 二维码过期时间
        this.expiryTimer = setTimeout(() => {
          this.qrRetry()
        }, ttl)
      } catch (e) {
        this.qrText = 'Error Code Rendered'
        const show_time = formatDate(new Date())
        login.REPORT.reportLoginPageShow({ show_time, login_type: REPORT_LOGIN_TYPE.officialAccount, page_show: 4 })
        this.qrRetry()
      }
    },

    loopMpAuth () {
      this.loopTimer = setInterval(() => {
        this.mpAuth()
      }, this.authCheckTime * 1000)
    },

    qrRetry () {
      this.retry = true
      this.clearLoopTimer()
    },

    /**
     * 轮询是否点关注,已关注直接回调
     * @returns {Promise<void>}
     */
    async mpAuth () {
      const res = await mpAuth({ identify: this.identify })
      const data = res.data

      if (res.auth_check_time && this.authCheckTime !== Number(res.auth_check_time)) {
        this.authCheckTime = res.auth_check_time
        this.clearLoopTimer()
        this.loopMpAuth()
      }

      if (!data || !data.user_info || !data.token) {
        return
      }

      this.clearLoopTimer()
      const show_time = formatDate(new Date())

      login.REPORT.reportLoginPageResult({
        result: 3,
        reason: '',
        login_type: REPORT_LOGIN_TYPE.officialAccount,
      })

      // 快速登录
      LoginHandler.quickLogin({ token: data.token, userInfo: data.user_info }).then(loginRes => {
        this.$emit('emitLoginRespond', loginRes, REPORT_LOGIN_TYPE.officialAccount)
      })
    },

    emitClickRetry () {
      this.getOfficialAccountLogin()
    },

    clearLoopTimer () {
      this.loopTimer && clearInterval(this.loopTimer)
    }
  }

}
</script>

<style scoped lang="scss">
@import '@/assets/css/sprite-login.scss';

  .qr-wrap{
    position: relative;
  }
  .qr-wrap-con{
    height: 150px;
  }
  .title, .title-print {
    font-size: 17px;
    color: #000;
    display: inline-block;
    line-height: 34px;
    margin-top: 10px;
    em{
      font-style: normal;
      font-weight: bold;
      color: #BD6603;
    }
  }
  .title-print{
    font-size: 16px;
    line-height: 25px;
    text-indent: 5px;
    font-weight: initial;
    color: #101010;
    em{
      color: #C69960;
    }
  }
  .qr-retry{
    position: absolute;
    top:0;
    left: 50%;
    transform: translateX(-50%);
  }

  .title-wrap{
    &:hover{
      .tips{
        display: block;
      }
    }
  }
  .tips-icon{
    display: inline-block;
    vertical-align: -2px;
    margin-left: 5px;
    height: 16px;
    width: 16px;
  }
  .tips{
    display: none;
    z-index: 1;
    position: absolute;
    bottom: -148px;
    right: 52px;
    height: 180px;
    width: 172px;
    &.tipsx{
      right: 82px;
      bottom: -156px;
    }
  }
</style>
